import esContent from './myData.es';

export default {
  ...esContent,
};
